@if (title()) {
  @if (postUrl()) {
    <a
      [href]="postUrl()"
      class="post-title-link"
      [target]="linkTarget()"
      (click)="onPostClick($event)"
      dataTest="post-title-link"
    >
      <div class="title" dataTest="post-title">
        {{ title() }}
      </div>
    </a>
  } @else {
    <div class="title" dataTest="post-title">
      {{ title() }}
    </div>
  }
}

@if (text()) {
  <div class="text-container">
    @if (postUrl()) {
      <a
        [href]="postUrl()"
        class="post-description-link"
        [target]="linkTarget()"
        (click)="onPostClick($event)"
        dataTest="post-description-link"
      >
        <ng-container [ngTemplateOutlet]="descriptionTemplate"></ng-container>
      </a>
    } @else {
      <ng-container [ngTemplateOutlet]="descriptionTemplate"></ng-container>
    }
  </div>
}

<ng-template #descriptionTemplate>
  <div #descriptionElement class="description" [class.expanding]="isAnimating()" [class.expanded]="isExpanded()">
    <span class="text-content" dataTest="post-description">
      {{ text() | formatLineBreaks | truncate: maxLength() }}
    </span>
    @if (shouldShowMoreButton()) {
      ...
      <button
        class="more-button-inline"
        dataTest="post-description-more-button"
        type="button"
        (click)="expandText($event)"
      >
        More
      </button>
    }
  </div>
</ng-template>
